import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.id_1 = id;
        this.name_1 = name;
        this.email_1 = email;
        this.badge_1 = badge;
        this.callSignAdjective_1 = callSignAdjective;
        this.callSignNoun_1 = callSignNoun;
        this.imageURL_1 = imageURL;
        this.avatarType_1 = avatarType;
        this.unvalidatedEmails_1 = unvalidatedEmails;
        this.pins_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.id_1.toString() + ', name=' + this.name_1 + ', email=' + this.email_1 + ', badge=' + toString(this.badge_1) + ', callSignAdjective=' + this.callSignAdjective_1 + ', callSignNoun=' + this.callSignNoun_1 + ', imageURL=' + toString(this.imageURL_1) + ', avatarType=' + toString(this.avatarType_1) + ', unvalidatedEmails=' + toString(this.unvalidatedEmails_1) + ', pins=' + toString(this.pins_1) + ')';
      }
      hashCode() {
        var result = this.id_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.email_1) | 0;
        result = imul(result, 31) + hashCode(this.badge_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignAdjective_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignNoun_1) | 0;
        result = imul(result, 31) + hashCode(this.imageURL_1) | 0;
        result = imul(result, 31) + hashCode(this.avatarType_1) | 0;
        result = imul(result, 31) + hashCode(this.unvalidatedEmails_1) | 0;
        result = imul(result, 31) + hashCode(this.pins_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.id_1.equals(other.id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.email_1 === other.email_1))
          return false;
        if (!equals(this.badge_1, other.badge_1))
          return false;
        if (!(this.callSignAdjective_1 === other.callSignAdjective_1))
          return false;
        if (!(this.callSignNoun_1 === other.callSignNoun_1))
          return false;
        if (!equals(this.imageURL_1, other.imageURL_1))
          return false;
        if (!equals(this.avatarType_1, other.avatarType_1))
          return false;
        if (!equals(this.unvalidatedEmails_1, other.unvalidatedEmails_1))
          return false;
        if (!equals(this.pins_1, other.pins_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
